import{html as t,svg as o}from"lit/html.js";import{watch as r}from"./watch.js";import{Signal as s}from"@preact/signals-core";
/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const m=t=>(o,...m)=>t(o,...m.map((t=>t instanceof s?r(t):t))),a=m(t),i=m(o);export{a as html,i as svg,m as withWatch};
//# sourceMappingURL=html-tag.js.map
